import SiteView   from 'components/Site/View';
import SignupForm from 'components/Forms/Signup';
import styles     from './signup-view.module.scss';

const SignupView = ({ title }) => {
	return (
		<SiteView>
			<div className={styles.root}>
				<SignupForm/>
			</div>
		</SiteView>
	)
}

export default SignupView;